import {colorTheme} from '../../../ui-toolkit/mixin/colorTheme';
import styled from 'styled-components';
import {ColorThemeShadow} from './ColorThemeShadow';

export const COLOR_OPTIONS = {
    '--primary      ': {dark: 'var(--blue-prime)             ', light: 'var(--blue-prime)'},
    '--subtle-primary-dark  ': {dark: 'var(--blue-prime)             ', light: 'var(--blue-prime)'},
    '--primary-dark ': {dark: '#036b9e             ', light: 'var(--blue-09)'},

    '--primary-table      ': {dark: 'var(--white-00) ', light: 'var(--black-01)'},
    '--primary-table-dark ': {dark: 'var(--blue-07)             ', light: 'var(--blue-prime)'},
    '--primary-light': {dark: '#e6f6ff             ', light: 'var(--blue-02)'},
    '--primary-ghost': {dark: '#2a9adc21             ', light: 'var(--blue-02)'},
    '--primary-notification': {dark: 'var(--blue-transp)', light: 'var(--blue-02)'},

    // === Green ===
    '--success     ': {dark: 'var(--green-03)', light: 'var(--green-prime)'},
    '--subtle-success-dark   ': {dark: 'var(--green-03)', light: 'var(--green-prime)'},
    '--success-dark': {dark: '#50873c', light: '#066b25'},
    '--success-light': {dark: '#eef8ea', light: 'var(--green-00)'},
    '--success-ghost': {dark: '#90f16917', light: 'var(--green-00)'},
    '--success-notification': {dark: 'var(--green-transp)', light: 'var(--green-00)'},

    // === Red ===
    '--danger         ': {dark: 'var(--red-04)  ', light: 'var(--red-01)'},
    '--subtle-danger-dark  ': {dark: 'var(--red-04)  ', light: 'var(--red-01)'},
    '--danger-light   ': {dark: '#ffeff1  ', light: 'var(--red-00)'},
    '--danger-ghost   ': {dark: '#ff6b7d1f  ', light: 'var(--red-00)'},
    '--danger-dark    ': {dark: '#a71d2a  ', light: 'var(--red-02)'},
    '--danger-dark-100': {dark: '#74131d  ', light: 'var(--red-03)'},
    '--danger-notification': {dark: 'var(--red-transp)', light: 'var(--red-00)'},

    '--confirmDanger     ': {dark: 'var(--white-00)               ', light: 'var(--white-00)'},
    '--confirmDanger-dark': {dark: 'var(--red-02)  ', light: 'var(--red-02)'},

    // === Yellow ===
    '--warning     ': {dark: 'var(--yellow-02)              ', light: 'var(--yellow-02)'},
    '--warning-dark': {dark: 'var(--yellow-03)              ', light: 'var(--yellow-03)'},
    '--warning-light': {dark: 'var(--yellow-00)            ', light: 'var(--yellow-00)'},
    '--warning-ghost': {dark: '#efab1524            ', light: 'var(--yellow-00)'},
    '--warning-100  ': {dark: 'var(--yellow-00)', light: 'var(--yellow-00)'},
    '--warning-200  ': {dark: 'var(--yellow-01)             ', light: 'var(--yellow-01)'},
    '--warning-notification': {dark: 'var(--yellow-transp)', light: 'var(--yellow-00)'},

    '--warning-table-row  ': {dark: 'var(--yellow-03)     ', light: 'var(--yellow-02)'},
    '--warning-table-row-light': {dark: 'var(--yellow-05)', light: 'var(--yellow-00)'},

    // === Orange ===
    '--caution      ': {dark: 'var(--orange-01)  ', light: 'var(--orange-01)'},
    '--caution-dark ': {dark: 'var(--orange-02)  ', light: 'var(--orange-02)'},
    '--caution-light': {dark: 'var(--orange-00)  ', light: 'var(--orange-00)'},
    '--caution-ghost': {dark: '#d25c0733  ', light: 'var(--orange-00)'},

    // === White ===
    '--blank     ': {dark: 'var(--gray-03)       ', light: 'var(--gray-03)'},
    '--blank-dark': {dark: 'var(--blue-08)', light: 'var(--blue-08)'},

    // === Dark gray ===
    '--default     ': {dark: 'var(--gray-10)  ', light: 'var(--gray-10)'},
    '--default-dark': {dark: 'var(--gray-12)  ', light: 'var(--gray-12)'},

    // === Gray ===
    '--disabled     ': {dark: 'var(--gray-09)  ', light: 'var(--gray-04)'},
    '--disabled-dark': {dark: 'var(--gray-09)  ', light: 'var(--gray-04)'},

    // === black ===
    '--secondary     ': {dark: 'var(--gray-13)  ', light: 'var(--gray-13)'},
    '--secondary-dark': {dark: 'var(--gray-14)  ', light: 'var(--gray-14)'},

    // === Gradient ====
    '--color-gradient-100': {dark: '#44a39f, #eb9664  ', light: '#44a39f, #eb9664'},
};

export const ColorThemePalette = styled(ColorThemeShadow)`
    ${colorTheme(COLOR_OPTIONS)};
`;
